// extracted by mini-css-extract-plugin
module.exports = {"title":"ModalTerms_title_Oom7_","titleBox":"ModalTerms_titleBox_1uMbv","modalWrapper":"ModalTerms_modalWrapper_2vS2I","modalClose":"ModalTerms_modalClose_pDDV_"};